import { debounce } from 'lodash';
import API from './API';
import { logout } from './logout';
import { sendEvent } from './analyticsEvents';
import { BackendReachability } from 'state/backendReachability';
import { HTTPRequestFactory, HTTPResponse, isHTTPErrorResponse } from 'hevy-shared/API';

export const initAPInterceptors = () => {
  API.attachRequestCompletionCallback(BackendReachability.handleResponse);
  API.attachErrorHandler(tokenRefreshFailedLogoutHandler);
  API.attachErrorHandler(invalidTokenLogoutInterceptor);
};

const tokenRefreshFailedLogoutHandler = (
  response: HTTPResponse,
  { method, url }: HTTPRequestFactory,
) => {
  if (
    method === API.refreshAuthTokenApiEndpoint.method &&
    url === API.refreshAuthTokenApiEndpoint.url
  ) {
    const { status } = response;

    if (
      status === 401 &&
      isHTTPErrorResponse(response) &&
      response.data.error === 'InvalidRefreshToken'
    ) {
      // If refreshing the auth token ever fails with a 401, log the user out.
      debouncedLogout();
    }
  }
};

const invalidTokenLogoutInterceptor = (
  res: HTTPResponse,
  _: HTTPRequestFactory,
  { isTokenRefreshedAfterRequest }: { isTokenRefreshedAfterRequest: boolean },
) => {
  if (API.isAccessTokenInvalidResponse(res) && !isTokenRefreshedAfterRequest) {
    debouncedLogout();
  }
};

const debouncedLogout = debounce(
  () => {
    sendEvent('invalid-auth-token-logout');
    console.warn('⚠️ Found invalid auth-token');
    logout('invalid-auth-token-interceptor');
  },
  5000,
  {
    leading: true,
    trailing: false,
  },
);
